<div class="container py-5">
  <div class="px-4 text-center">
    <h1 style="color: var(--primary-color)" class="display-5  ">¿Cómo lograr un <span class="fw-bold">trabajo sano y seguro?</span></h1>
    <h4 style="color: var(--primary-color)" class="  fs-3">Te ayudamos a lograrlo con:</h4>
  </div>
</div>


<div class="container px-4 py-2" id="icon-grid">
  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4 py-5">
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/examenes-ocupacionales-periodicos">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/ocupacionalesPeriodicos.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Exámenes <span class="fw-bolder"> Ocupacionales periódicos </span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/examenes-pre-post-ocupacional">

      <div class="container d-flex align-items-center">
      <img src="/assets/img/enterprise/menu/ocupacionalesPrePost.svg" width="80" height="80" alt="">
      <div class="w-50">
        <h5 class=" mx-2 fs-5 ">Exámenes Pre y Post <span class="fw-bolder">Ocupacionales</span></h5>
      </div>
      </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/medicos-para-dispensario">
      <div class="container d-flex align-items-center">

      <img src="/assets/img/enterprise/menu/medicosDispensarios.svg" width="80" height="80" alt="">
      <div class="w-50">
        <h5 class=" mx-2 fs-5 "> <span class="fw-bolder"> Medicos</span> para dispensarios</h5>
      </div>
      </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/terapia-fisica-traumotologia">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/terapiaFisicaTraumo.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 "> <span class="fw-bolder">Terapia física </span> y <span class="fw-bolder">traumatología</span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/terapia-psicologica-salud-mental">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/psicologiaSaludMental.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Terapia psicológica y <span class="fw-bolder">salud mental</span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/nutricion-dietetica">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/nutricionDieta.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Nutrición y <span class="fw-bolder">Dietética</span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/ferias-charlas-salud">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/feriasCharlas.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Ferias y Charlas <span class="fw-bolder">de Salud</span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/servicio-ambulancia">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/ambulanciaServicio.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Servicios de <span class="fw-bolder">Ambulancia</span></h5>
          </div>
        </div>
      </a>
    </div>
    <div class="col d-flex align-items-start ">
      <a routerLink="/empresa/botiquin-empresarial">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/botiquinEmpresarial.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Botiquin <span class="fw-bolder">Empresarial</span></h5>
          </div>
        </div>
      </a>
    </div>
 <!--   <div class="col d-flex mx-auto align-items-start ">
      <a routerLink="">

        <div class="container d-flex align-items-center">

          <img src="/assets/img/enterprise/menu/proyectosEspeciales.svg" width="80" height="80" alt="">
          <div class="w-50">
            <h5 class=" mx-2 fs-5 ">Proyectos <span class="fw-bolder">Especiales</span></h5>
          </div>
        </div>
      </a>
    </div>-->

  </div>
</div>

<div class="container w-50">
  <img src="/assets/img/enterprise/menu/SGS%20.svg" alt="">
</div>
